import React, { ReactNode } from 'react';

import useConnectors, { ConnectorsHook } from 'features/connectors/context/connectors-hook';

const ConnectorsContext = React.createContext<ConnectorsHook>({} as never);

interface Props {
  children: ReactNode;
}

export const ConnectorsProvider = ({ children }: Readonly<Props>) => {
  return <ConnectorsContext.Provider value={useConnectors()}>{children}</ConnectorsContext.Provider>;
};

export const useConnectorsContextProvider = (): ConnectorsHook => React.useContext<ConnectorsHook>(ConnectorsContext);
